import { IOperationalAlert } from '../types/operations.types'

export const MOCK_ALERTS: IOperationalAlert[] = [
  {
    id: 'alert-001',
    severity: 'critical',
    title: 'Fuel Risk - Truck 7',
    description: 'Estimated empty in 45 min',
    timestamp: new Date(Date.now() - 12 * 60000).toISOString(),
    actionLabel: 'Start refuel workflow',
    actionPath: '/operations/triggers',
  },
  {
    id: 'alert-002',
    severity: 'critical',
    title: 'CAT320 Hydraulic Warning',
    description: 'Pressure anomaly detected',
    timestamp: new Date(Date.now() - 25 * 60000).toISOString(),
    actionLabel: 'Open maintenance case',
    actionPath: '/operations/department',
  },
  {
    id: 'alert-003',
    severity: 'warning',
    title: 'Workforce Gap - Night Shift',
    description: '2 operators unassigned',
    timestamp: new Date(Date.now() - 45 * 60000).toISOString(),
    actionLabel: 'Review crew allocation',
    actionPath: '/hr/schedule',
  },
  {
    id: 'alert-004',
    severity: 'warning',
    title: 'Queue Underfill - Zone B',
    description: 'Horizon below threshold',
    timestamp: new Date(Date.now() - 60 * 60000).toISOString(),
    actionLabel: 'Check scheduler',
    planId: 'plan-002',
  },
  {
    id: 'alert-005',
    severity: 'info',
    title: 'Shift Handover in 45 min',
    description: 'Prepare shift reports',
    timestamp: new Date(Date.now() - 5 * 60000).toISOString(),
    actionLabel: 'View handover checklist',
  },
]
